<a
  *ngIf="
    routerLink !== undefined && routerLink !== null;
    else withoutRouterLink
  "
  class="btn btn-secondary-action btn-md"
  [ngClass]="classes"
  [routerLink]="routerLink"
  [queryParams]="queryParams"
  [attr.title]="titleKey ? (titleKey | translate) : null"
  [attr.data-testid]="dataTestid"
  [attr.aria-disabled]="disabled"
  [class.disabled]="disabled"
  (click)="onClick($event)"
>
  {{ labelKey | translate }}
</a>
<ng-template #withoutRouterLink>
  <app-button
    *ngIf="matDialogClose !== undefined; else withoutDialogClose"
    variant="secondary"
    [size]="size"
    [disabled]="disabled"
    [classes]="classes"
    [dataTestid]="dataTestid"
    [attr.title]="titleKey ? (titleKey | translate) : null"
    [mat-dialog-close]="matDialogClose"
    (click)="onClick($event)"
  >
    {{ labelKey | translate }}
  </app-button>
  <ng-template #withoutDialogClose>
    <app-button
      variant="secondary"
      [size]="size"
      [disabled]="disabled"
      [classes]="classes"
      [dataTestid]="dataTestid"
      [attr.title]="titleKey ? (titleKey | translate) : null"
      (click)="onClick($event)"
    >
      {{ labelKey | translate }}
    </app-button>
  </ng-template>
</ng-template>
